<dx-data-grid [dataSource]="people"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              (onInitialized)="onGridInitialized($event)">
    <!-- Options -->
    <dxo-header-filter [visible]="true"> </dxo-header-filter>
    <dxo-filter-row [visible]="true"> </dxo-filter-row>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
    <dxo-export [enabled]="true"
                fileName="People"> </dxo-export>
    <dxo-pager [showPageSizeSelector]="true"
               [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-pager>

    <!-- Columns -->
    <dxi-column caption="Id"
                dataField="personId"
                dataType="number"> </dxi-column>

    <dxi-column caption="Full Name"
                dataField="fullName"
                dataType="string"
                cellTemplate="nameCellTemplate"> </dxi-column>

    <dxi-column caption="Active Organisations"
                [calculateCellValue]="calculateOrganisationColumnValue"
                cellTemplate="organisationCellTemplate"
                dataType="string"
                dataField="dummy_organisations"
                [allowFiltering]="true"
                [visible]="false"> </dxi-column>

    @for (contactTypeMetadata of AllContactTypeMetadata; track contactTypeMetadata) {
        <dxi-column [caption]="contactTypeMetadata.name"
                    cellTemplate="contactDetailCellTemplate"
                    [allowFiltering]="true"
                    [allowHeaderFiltering]="false"
                    [allowSorting]="false"
                    dataType="string"
                    [dataField]="contactTypeMetadata.name"
                    [visible]="contactTypeMetadata.type !== ContactType.Address && contactTypeMetadata.type !== ContactType.Messaging">
        </dxi-column>
    }

    @if (filterForOrganisationId) {
        <dxi-column caption="User Type"
                    [calculateCellValue]="calculateUserTypeColumnValue"
                    dataField="dummy_userType"
                    dataType="string"
                    [visible]="true"> </dxi-column>
    }

    @if (filterForOrganisationId) {
        <dxi-column caption="Has Platform Access"
                    [calculateCellValue]="calculateHasPlatformAccessColumnValue"
                    dataField="dummy_hasAccess"
                    dataType="boolean"
                    [visible]="true"> </dxi-column>
    }

    @if (filterForOrganisationId) {
        <dxi-column caption="Last Access"
                    dataField="LastAccess"
                    dataType="date"
                    [format]="DateFormats.globalize.short"> </dxi-column>
    }

    <dxi-column caption="Status"
                [calculateCellValue]="calculateActiveCellValue"
                dataType="boolean"
                dataField="dummy_status"
                trueText="Active"
                falseText="Inactive"
                [allowSorting]="true"
                [showEditorAlways]="false"
                [filterValue]="true"
                [allowFiltering]="true"
                [visible]="true"> </dxi-column>

    @if (filterForOrganisationId) {
        <dxi-column caption="Connection Type"
                    [calculateCellValue]="calculateConnectionTypeColumnValue"
                    dataField="dummy_connectionType"
                    dataType="string"
                    [visible]="false"> </dxi-column>
    }

    <!-- Templates -->
    <div *dxTemplate="let item of 'nameCellTemplate'">
        <adapt-link-person [person]="item.data"></adapt-link-person>
    </div>

    <div *dxTemplate="let item of 'contactDetailCellTemplate'">
        <ul>
            @for (detail of getContactsOfTypeByName(item.data, item.column.caption); track detail) {
                <li>
                    <adapt-contact-detail [detail]="detail"></adapt-contact-detail>
                </li>
            }
        </ul>
    </div>

    <div *dxTemplate="let item of 'organisationCellTemplate'">
        <ul>
            @for (organisation of getUniqueActiveOrganisationsFromConnections(item.data.connections); track organisation) {
                <li>
                    <adapt-link-organisation [organisation]="organisation"></adapt-link-organisation>
                </li>
            }
        </ul>
    </div>
</dx-data-grid>
